import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

class EBikeBatteryProducts extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    const products = [
      {
        id: 1,
        image: "assets/img/product-3/eco-dash.png",
        badgeText: "For Rent",
        badgeClass: "bg-green",
        location: "Belmont Gardens, Chicago",
        gallery: { photos: 4, videos: 2 },
        price: "$34,900",
        duration: "/Month",
        title: "1.8 kWh LiFePO4",
        type: "Solar Battery",
        category: "EV-Battery",
        route: "/e-bike-battery/eco-dash",
        description:
          "A high-performance lithium  battery for use in electric 2-wheelers.",
        details: {
          power_output: `64V / 1.92kWh`,
          voltage_range: `2,000`,
          weight: `LiFePO`,
          local_warranty: "3 Years",
        },
        agent: {
          name: "Atom Power",
          image: "assets/img/blog/author.jpg",
          role: "EV Battery - Atom Power.",
        },
      },
      {
        id: 2,
        image: "assets/img/product-3/eco-cruise.png",
        badgeText: "For Rent",
        badgeClass: "bg-green",
        location: "Belmont Gardens, Chicago",
        gallery: { photos: 4, videos: 2 },
        price: "$34,900",
        duration: "/Month",
        title: "2.2 kWh LiFePO4",
        type: "Solar Inverter",
        category: "EV-Battery",
        route: "/e-bike-battery/eco-cruise",
        description:
          "A high-performance lithium  battery for use in electric 2-wheelers.",
        details: {
          power_output: `73.6V / 2.2kWh`,
          voltage_range: `2,000`,
          weight: `LiFePO`,
          local_warranty: "3 Years",
        },
        agent: {
          name: "Atom Power",
          image: "assets/img/blog/author.jpg",
          role: "EV Battery - Atom Power.",
        },
      },
      {
        id: 3,
        image: "assets/img/product-3/eco-powerbolt.png",
        badgeText: "For Sale",
        badgeClass: "bg-green---",
        location: "Belmont Gardens, Chicago",
        gallery: { photos: 4, videos: 2 },
        price: "$34,900",
        duration: "/Month",
        title: "7.2 kWh LiFePO4",
        type: "Solar Inverter",
        category: "EV-Battery",
        route: "/e-bike-battery/eco-powerbolt",
        description:
          "A high-performance lithium  battery for use in electric 2-wheelers & 3-wheelers. ",
        details: {
          power_output: `73.6V / 7.4kWh`,
          voltage_range: `4,500`,
          weight: `LiFePO`,
          local_warranty: "3 Years",
        },
        agent: {
          name: "Atom Power",
          image: "assets/img/blog/author.jpg",
          role: "EV Battery - Atom Power.",
        },
      },
    ];

    return (
      <div>
        <div className="ltn__product-slider-area ltn__product-gutter">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title-area ltn__section-title-2--- text-center">
                  {/* <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                    Products
                  </h6> */}
                  <h1 className="section-title"> E Bike Battery Solutions</h1>
                </div>
              </div>
            </div>
            {/* Products */}
            <div className="row ltn__product-slider-item-three-active slick-arrow-1">
              {products.map((product) => (
                <div key={product.id} className="col-lg-12">
                  <div
                    className="ltn__product-item ltn__product-item-4 text-center---"
                    style={{
                      backgroundColor: "#F2F6F7",
                      boxShadow: "0 1px 6px 0 rgba(32, 33, 36, 0.28)",
                    }}
                  >
                    <div
                      className="product-img go-top"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <Link to={product.route}>
                        <img src={product.image} alt={product.title}  style={{
    width: "100%",
    height: "250px",
    objectFit: "cover",
    padding: "10px 0",

  }} />
                      </Link>
                      {/* <div className="product-badge">
                                    <ul>
                                      <li className={`sale-badge ${product.badgeClass}`}>
                                        {product.badgeText}
                                      </li>
                                    </ul>
                                  </div> */}

                      {/* <div className="product-img-location-gallery">
                                    <div className="product-img-location go-top">
                                      <ul>
                                        <li>
                                          <Link to="/contact">
                                            <i className="flaticon-pin" />{" "}
                                            {product.location}
                                          </Link>
                                        </li>
                                      </ul>
                                    </div>
                                    <div className="product-img-gallery go-top">
                                      <ul>
                                        <li>
                                          <Link to="/product-details">
                                            <i className="fas fa-camera" />{" "}
                                            {product.gallery.photos}
                                          </Link>
                                        </li>
                                        <li>
                                          <Link to="/product-details">
                                            <i className="fas fa-film" />{" "}
                                            {product.gallery.videos}
                                          </Link>
                                        </li>
                                      </ul>
                                    </div>
                                  </div> */}
                    </div>
                    <div
                      className="product-info"
                      style={{ padding: "2px 20px 1px" }}
                    >
                      <div className="product-price">
                        {/* <span>
                                      {product.price}
                                      <label>{product.duration}</label>
                                    </span> */}
                        <h6>{product?.category}</h6>
                      </div>
                      {/* <h2
                        className="product-title go-top"
                        style={{ fontSize: "19px" }}
                      >
                        <Link to={product.route}>{product.title}</Link>
                      </h2> */}
                      <h2
  className="product-title go-top"
  style={{ fontSize: "19px" }}
>
  <Link to={product.route}>
    {product.title.includes("LiFePO4") ? (
      <>
        {product.title.replace("LiFePO4", "LiFePO")}
        <sub>4</sub>
      </>
    ) : (
      product.title
    )}
  </Link>
</h2>
                      <div className="product-description">
                        <p>{product.description}</p>
                      </div>
                      <ul className="ltn__list-item-2 ltn__list-item-2-before">
                        <li>
                          <span>
                            {product.details.power_output}{" "}
                            {/* <i className="flaticon-bed" /> */}
                          </span>
                          {/* {product.type == "Solar Battery"
                            ? "Capacity"
                            : "Rated Power"} */}
                          Voltage/Capacity
                        </li>
                        <li>
                          <span>
                            {/* {product.type == "Solar Battery"
                              ? product.details.voltage_range
                              : product.details.local_warranty} */}
                            {product.details.voltage_range}
                            {/* <i className="flaticon-clean" /> */}
                          </span>
                          {/* {product.type == "Solar Battery"
                            ? "Nominal Voltage"
                            : "Local Warranty"} */}
                          Life Cycles
                        </li>
                        <li>
                          <span>
                            {product.details.weight}<sub>4</sub>{" "}
                            {/* <i className="flaticon-square-shape-design-interface-tool-symbol" /> */}
                          </span>
                          Battery Type
                        </li>
                      </ul>
                    </div>
                    <div className="product-info-bottom">
                      <div className="real-estate-agent go-top">
                        {/* <div className="agent-img">
                                      <Link to="/team-details">
                                        <img
                                          src={product.agent.image}
                                          alt={product.agent.name}
                                        />
                                      </Link>
                                    </div> */}
                        <div className="agent-brief">
                          <h6>
                            {/* <Link
                                        to="/team-details"
                                        >
                                          {product.agent.name}
                                        </Link> */}
                            {/* {product.agent.name} */}
                          </h6>
                          <small>{product.agent.role}</small>
                        </div>
                      </div>
                      {/* <div className="product-hover-action">
                                    <ul>
                                      <li>
                                        <a
                                          href="#"
                                          title="Quick View"
                                          data-bs-toggle="modal"
                                          data-bs-target="#quick_view_modal"
                                        >
                                          <i className="flaticon-expand" />
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          href="#"
                                          title="Wishlist"
                                          data-bs-toggle="modal"
                                          data-bs-target="#liton_wishlist_modal"
                                        >
                                          <i className="flaticon-heart-1" />
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          href="product-details.html"
                                          title="Product Details"
                                        >
                                          <i className="flaticon-add" />
                                        </a>
                                      </li>
                                    </ul>
                                  </div> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="ltn__modal-area ltn__add-to-cart-modal-area">
          <div className="modal fade" id="liton_wishlist_modal" tabIndex={-1}>
            <div className="modal-dialog modal-md" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="ltn__quick-view-modal-inner">
                    <div className="modal-product-item">
                      <div className="row">
                        <div className="col-12">
                          <div className="modal-product-img">
                            <img
                              src={publicUrl + "assets/img/product/7.png"}
                              alt="#"
                            />
                          </div>
                          <div className="modal-product-info go-top">
                            <h5>
                              <Link to="/product-details">
                                Brake Conversion Kit
                              </Link>
                            </h5>
                            <p className="added-cart">
                              <i className="fa fa-check-circle" /> Successfully
                              added to your Wishlist
                            </p>
                            <div className="btn-wrapper">
                              <Link
                                to="/wishlist"
                                className="theme-btn-1 btn btn-effect-1"
                              >
                                View Wishlist
                              </Link>
                            </div>
                          </div>
                          {/* additional-info */}
                          <div className="additional-info d-none">
                            <p>
                              We want to give you <b>10% discount</b> for your
                              first order, <br /> Use discount code at checkout
                            </p>
                            <div className="payment-method">
                              <img
                                src={publicUrl + "assets/img/icons/payment.png"}
                                alt="#"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ltn__modal-area ltn__quick-view-modal-area">
          <div className="modal fade" id="quick_view_modal" tabIndex={-1}>
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                    {/* <i class="fas fa-times"></i> */}
                  </button>
                </div>
                <div className="modal-body">
                  <div className="ltn__quick-view-modal-inner">
                    <div className="modal-product-item">
                      <div className="row">
                        <div className="col-lg-6 col-12">
                          <div className="modal-product-img">
                            <img
                              src={publicUrl + "assets/img/product/4.png"}
                              alt="#"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-12">
                          <div className="modal-product-info">
                            <div className="product-ratting">
                              <ul>
                                <li>
                                  <a href="#">
                                    <i className="fas fa-star" />
                                  </a>
                                </li>
                                <li>
                                  <a href="#">
                                    <i className="fas fa-star" />
                                  </a>
                                </li>
                                <li>
                                  <a href="#">
                                    <i className="fas fa-star" />
                                  </a>
                                </li>
                                <li>
                                  <a href="#">
                                    <i className="fas fa-star-half-alt" />
                                  </a>
                                </li>
                                <li>
                                  <a href="#">
                                    <i className="far fa-star" />
                                  </a>
                                </li>
                                <li className="review-total">
                                  {" "}
                                  <a href="#"> ( 95 Reviews )</a>
                                </li>
                              </ul>
                            </div>
                            <h3>Brake Conversion Kit</h3>
                            <div className="product-price">
                              <span>$149.00</span>
                              <del>$165.00</del>
                            </div>
                            <div className="modal-product-meta ltn__product-details-menu-1">
                              <ul>
                                <li>
                                  <strong>Categories:</strong>
                                  <span className="go-top">
                                    <Link to="/blog">Parts</Link>
                                    <Link to="/blog">Car</Link>
                                    <Link to="/blog">Seat</Link>
                                    <Link to="/blog">Cover</Link>
                                  </span>
                                </li>
                              </ul>
                            </div>
                            <div className="ltn__product-details-menu-2">
                              <ul>
                                <li>
                                  <div className="cart-plus-minus">
                                    <input
                                      type="text"
                                      defaultValue="02"
                                      name="qtybutton"
                                      className="cart-plus-minus-box"
                                    />
                                  </div>
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    className="theme-btn-1 btn btn-effect-1"
                                    title="Add to Cart"
                                    data-bs-toggle="modal"
                                    data-bs-target="#add_to_cart_modal"
                                  >
                                    <i className="fas fa-shopping-cart" />
                                    <span>ADD TO CART</span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <hr />
                            <div className="ltn__social-media">
                              <ul>
                                <li>Share:</li>
                                <li>
                                  <a href="#" title="Facebook">
                                    <i className="fab fa-facebook-f" />
                                  </a>
                                </li>
                                <li>
                                  <a href="#" title="Twitter">
                                    <i className="fab fa-twitter" />
                                  </a>
                                </li>
                                <li>
                                  <a href="#" title="Linkedin">
                                    <i className="fab fa-linkedin" />
                                  </a>
                                </li>
                                <li>
                                  <a href="#" title="Instagram">
                                    <i className="fab fa-instagram" />
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ltn__modal-area ltn__add-to-cart-modal-area">
          <div className="modal fade" id="add_to_cart_modal" tabIndex={-1}>
            <div className="modal-dialog modal-md" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="ltn__quick-view-modal-inner">
                    <div className="modal-product-item">
                      <div className="row">
                        <div className="col-12">
                          <div className="modal-product-img">
                            <img
                              src={publicUrl + "assets/img/product/1.png"}
                              alt="#"
                            />
                          </div>
                          <div className="modal-product-info go-top">
                            <h5 className="go-top">
                              <Link to="/product-details">
                                Brake Conversion Kit
                              </Link>
                            </h5>
                            <p className="added-cart">
                              <i className="fa fa-check-circle" />
                              Successfully added to your Cart
                            </p>
                            <div className="btn-wrapper">
                              <Link
                                to="/cart"
                                className="theme-btn-1 btn btn-effect-1"
                              >
                                View Cart
                              </Link>
                              <Link
                                to="/checkout"
                                className="theme-btn-2 btn btn-effect-2"
                              >
                                Checkout
                              </Link>
                            </div>
                          </div>
                          {/* additional-info */}
                          <div className="additional-info d-none">
                            <p>
                              We want to give you <b>10% discount</b> for your
                              first order, <br /> Use discount code at checkout
                            </p>
                            <div className="payment-method">
                              <img
                                src={publicUrl + "assets/img/icons/payment.png"}
                                alt="#"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EBikeBatteryProducts;
